import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "dialog-mask"
};
var _hoisted_2 = {
  class: "dialog-header"
};
var _hoisted_3 = {
  key: 0,
  class: "title"
};
var _hoisted_4 = {
  class: "dialog-body"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  class: "dialog-footer"
};
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.classes)
  }, [_withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [[_vShow, $data.visible]]), _createVNode(_Transition, {
    name: "animate-fadein"
  }, {
    default: _withCtx(function () {
      return [_withDirectives(_createElementVNode("div", {
        class: "dialog-containner",
        style: _normalizeStyle($options.styles)
      }, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "header", {}, function () {
        return [$props.title ? (_openBlock(), _createElementBlock("em", _hoisted_3, _toDisplayString($props.title), 1)) : _createCommentVNode("", true)];
      })]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "default", {}, function () {
        return [_createElementVNode("div", {
          class: "p",
          innerHTML: $props.message
        }, null, 8, _hoisted_5)];
      })]), _renderSlot(_ctx.$slots, "footer", {}, function () {
        return [_createElementVNode("div", _hoisted_6, [$props.showCancel ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-cancel",
          innerHTML: $props.cancelText,
          onClick: _cache[0] || (_cache[0] = function () {
            return $options.handleCancel && $options.handleCancel.apply($options, arguments);
          })
        }, null, 8, _hoisted_7)) : _createCommentVNode("", true), _createElementVNode("button", {
          class: "btn-confirm",
          innerHTML: $props.confirmText,
          onClick: _cache[1] || (_cache[1] = function () {
            return $options.handleConfirm && $options.handleConfirm.apply($options, arguments);
          })
        }, null, 8, _hoisted_8)])];
      })], 4), [[_vShow, $data.visible]])];
    }),
    _: 3
  })], 2)), [[_vShow, $data.visible]]);
}